import React from 'react';
import { noData } from '../../utils/string';
import { useIntl } from 'react-intl';
import { formatDateForDisplay } from '../../utils/date';
import { applicationStatus } from '../../utils';
import startCase from 'lodash.startcase';
import makeStyles from '@material-ui/core/styles/makeStyles';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import moment from 'moment';
import RequestChangeDialog from './RequestChanges/Dialog';
import CustomTooltip from '../BuildingBlocks/Tooltip/Tooltip';
import PaymentStatus from './PaymentStatus';

const useStyles = makeStyles((theme: any) => ({
  root: {
    '& .MuiTableCell-root': {
      padding: 0,
      height: ({ height }: any) => {
        return height;
      },
    },
  },
  past_due: { backgroundColor: '#FDECEA' },
  adjustBalanceRow: { fontStyle: 'italic' },
  italicFont: { fontStyle: 'italic' },
}));

const calculateStatus = ({ adjustBalanceRow, status }) => {
  return adjustBalanceRow ? 'scheduled' : status;
};

export default function PaymentTableBody({
  payments,
  includeStatus,
  setLoading,
  setPayments,
  planStatus,
}) {
  const tableRowHeight = 55;
  const classes = useStyles({ height: tableRowHeight });
  const { formatNumber } = useIntl();

  const setReviewPayment = (payment) => {
    const updatedPayments = payments.map((p, i) => {
      if (p.id === payment.id) {
        return {
          ...payment,
          paymentStatus: 'review',
        };
      } else {
        return p;
      }
    });

    setPayments(updatedPayments);
  };

  function getPaymentRowTooltip(payment) {
    let tooltip = '';
    if (payment.adjustBalanceRow) {
      if (planStatus === applicationStatus.pending.status) {
        tooltip =
          'This one-time adjustment will be executed within 5 business days of acceptance, and is the result of the change(s) you requested.';
      } else if (payment.approvedAt) {
        tooltip = `This one-time adjustment was accepted on ${moment(
          payment.approvedAt,
        ).format('MM/DD/YYYY')} following the change(s) you requested.`;
      } else {
        tooltip = `This one-time adjustment following the change(s) you requested.`;
      }
    }
    return tooltip;
  }

  return (
    <TableBody>
      {payments.length === 0 && (
        <TableRow>
          <TableCell colSpan={5} align="center">
            <h2>No funds deliveries matching filter.</h2>
          </TableCell>
        </TableRow>
      )}
      {payments.map((p, i) => {
        return (
          <CustomTooltip
            arrow
            placement="top"
            title={getPaymentRowTooltip(p)}
            key={i}
          >
            <TableRow
              key={i}
              className={p.adjustBalanceRow && classes.adjustBalanceRow}
            >
              <TableCell>
                {p.adjustBalanceRow
                  ? 'Rebalance (STAT)'
                  : formatDateForDisplay(p.startDate)}
              </TableCell>
              <TableCell>
                {p.loan !== 0 && <div>${formatNumber(p.loan)}</div>}
                {p.loan === 0 && noData()}
              </TableCell>
              <TableCell>
                {!p.participation ? (
                  noData()
                ) : (
                  <div>${formatNumber(p.participation)}</div>
                )}
              </TableCell>
              <TableCell>
                {!p.payback ? (
                  noData()
                ) : (
                  <div>${formatNumber(p.payback * -1)}</div>
                )}
              </TableCell>
              {includeStatus && (
                <>
                  <PaymentStatus
                    status={p.status}
                    paymentStatus={p.paymentStatus}
                    adjustBalanceRow={p.adjustBalanceRow}
                    calculateStatus={calculateStatus}
                  />
                  <TableCell style={{ padding: '0px' }}>
                    {!p.adjustBalanceRow && (
                      <RequestChangeDialog
                        payment={p}
                        status={startCase(calculateStatus(p))}
                        setLoading={setLoading}
                        setReviewPayment={setReviewPayment}
                      />
                    )}
                  </TableCell>
                </>
              )}
            </TableRow>
          </CustomTooltip>
        );
      })}
    </TableBody>
  );
}
